// Components
import Grid from "@mui/material/Grid";

type VideoCardContainerType = {
  backgroundColor?: string;
  children: React.ReactNode;
};

const VideoCardContainer = ({
  backgroundColor = "#202338",
  children,
}: VideoCardContainerType) => {
  return (
    <Grid
      container
      display="flex"
      flexDirection="column"
      gap="8px"
      width="100%"
      minWidth={0}
      padding="8px"
      borderRadius="8px"
      sx={{
        backgroundColor,
      }}
    >
      {children}
    </Grid>
  );
};

export default VideoCardContainer;
